module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crt",
    attrs: {
      "id": "cop"
    }
  }, [_vm._v("Dead Aim"), _c('br'), _vm._v("Copyright © 1990 by Ridley Pearson")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Electronic edition published 2015 by RosettaBooks"), _c('br'), _vm._v("\nCover design by David Ter-Avanesyan/Ter33Design"), _c('br'), _vm._v("\nISBN e-Pub edition: 9780795346446"), _c('br'), _vm._v("\nwww.RosettaBooks.com")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d230dbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/cop.vue
// module id = 63
// module chunks = 0